import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { CreateNewCVPCandidateParametersSimple } from "./CreateNewCVPCandidateParametersSimple";

export interface CreateProfileResponse extends BackendResponse {
  item: string;
}

export interface CreateProfileParameters extends NextApiParams {
  /**
   * firstName: string;
   * lastName: string;
   * dob: string | null;
   * mobile: string;
   * zipCode: string;
   * typeNationality: number | null;
   * email: string;
   * acceptedGeneralConsent: boolean;
   * idDepartmentOfChoice: number | null;
   * idLanguage: number | null;
   * concernId: number;
   * files: any[] | null;
   */
  formData: FormData;
}

export const createProfile = withNextApi<
  CreateProfileResponse,
  CreateProfileParameters
>("/auth/CreateProfile");
